import { Link } from "wouter";
import { CLIENT_PHOTOS } from "@/lib/constants";

export function ClientMarquee() {
  const photos = [...CLIENT_PHOTOS, ...CLIENT_PHOTOS];

  return (
    <div className="marquee-pause-on-hover marquee-mask overflow-hidden">
      <div className="marquee-track flex w-max gap-4 md:gap-6">
        {photos.map((photo, idx) => (
          <Link
            key={`${photo.src}-${idx}`}
            href="/shop"
            aria-label="Shop the edit"
            className="group block shrink-0"
          >
            <div className="aspect-[4/5] h-64 md:h-80 overflow-hidden rounded-2xl bg-light-taupe shadow-sm transition-transform duration-500 group-hover:scale-[1.02]">
              <img
                src={photo.src}
                alt={photo.alt}
                width={640}
                height={800}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
                draggable={false}
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
